import { Select } from "@/components/ui";
import { kindWord } from "@/lib/attributeReview/kindWords";

import { KindChips } from "./KindChips";
import type { KindOption } from "./types";

type Props = {
  kinds: KindOption[];
  kind: string | null;
  splitKinds?: string[];
  label: string;
  onKind: (kind: string) => void;
};

export function KindControl({
  kinds,
  kind,
  splitKinds = [],
  label,
  onKind,
}: Props) {
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm text-slate-900 dark:text-slate-100">
      <span>{label}</span>
      <KindChips options={splitKinds} kind={kind} onKind={onKind} />
      <Select
        aria-label="Kind"
        className="w-72"
        value={kind ?? ""}
        onChange={(event) => onKind(event.target.value)}
      >
        <option value="" disabled>
          pick a kind
        </option>
        {kinds.map((option) => (
          <option key={option.kind} value={option.kind}>
            {kindWord(option.kind)} ({option.folder})
          </option>
        ))}
      </Select>
    </div>
  );
}
